import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';

import React from 'react';
import axios from 'axios';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

async function fileDownload(documentPath) {
  let headers = {
    Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
    'Access-Control-Allow-Origin': '*',
    'x-api-key': process.env.REACT_APP_X_API_KEY,
  };
  axios
    .get(
      process.env.REACT_APP_UPLOAD_DOWNLOAD +
        config['api'] +
        '/download?objectId=' +
        documentPath,
      {
        headers: headers,
        responseType: 'blob',
      }
    )
    .then((response) => {
      //Create a Blob from the PDF Stream

      var re = /(?:\.([^.]+))?$/;

      var ext = re.exec(documentPath)[1]; // "txt"
      const MimeTypesMap = {
        png: 'image/png',
        gif: 'image/gif',
        jpg: 'image/jpg',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf',
        mp4: 'video/mp4',
        doc: 'application/msword',
        docx:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.ms-powerpoint',
        xlsx:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      };

      const mimeType = MimeTypesMap[ext];

      const file = new Blob([response.data], { type: mimeType });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      if (mimeType === 'application/pdf') {
        window.open(fileURL, '_blank');
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentPath); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error) => {});
}

export const INCIDENTS_DATE_GRID = async (
  url,
  fromDate,
  toDate,
  incType,
  closure,
  storeId,
  alert
) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] +
      url +
      '?fromDate=' +
      fromDate +
      '&toDate=' +
      toDate +
      '&incidentType=' +
      incType +
      '&status=' +
      closure +
      '&storeId=' +
      storeId +
      '&alertLevel=' +
      alert
  )
    .then((response) => response.json())
    .then((response) => {
      let body = [];
      let stores = [];
      let colorCodes = [];
      let storeID = [];
      let proxyjson = [];
      response.conditionalWebGrids.map((name, val) => {
        if (name.pdfPath == null) {
          body.push([
            name.incidentType,
            name.alertLevel,
            name.incidentCreatedBy,
            name.incidentCreatedDate,
            name.incidentClosedDate,
            name.incidentStatus,
            'No Document Available',
          ]);
        } else {
          body.push([
            name.incidentType,
            name.alertLevel,
            name.incidentCreatedBy,
            name.incidentCreatedDate,
            name.incidentClosedDate,
            name.incidentStatus,
            <button
              className='link-button'
              onClick={() => fileDownload(name.pdfPath)}
              style={{ cursor: 'pointer' }}
            >
              {' '}
              View Document
            </button>,
          ]);
        }

        stores.push(name.incidentDate);
        storeID.push(name.incidentDate);
        colorCodes.push([0, 0, 0, 0, 0, 0, 0]);
      });
      return (proxyjson = {
        type: 'IncidentsDateGrid',
        thead: [
          'Incident Date',
          'Incident Type',
          'Alert Level',
          'Incident Created By',
          'Incident Created Date',
          'Incident Closed Date',
          'Incident Satus',
          'View Document',
        ],
        storeId: storeID,
        popUpDataGrid: 'none',
        popUpDataGridHeaders: ['Not Required'],
        tbody: body,
        columns: [
          'Incident Date',
          'Incident Type',
          'Alert Level',
          'Incident Created By',
          'Incident Created Date',
          'Incident Closed Date',
          'Incident Satus',
          'View Document',
        ],
        stores: stores,
        colorCodes: colorCodes,
        excelData: response.conditionalWebGrids,
      });
    });
  return fetchedData;
};
